import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {BookingAppointmentDto, BookingSlotDto, BookingTimePeriodDto} from "../../../bookings/types/bookings.types";

@Component({
  selector: 'schedule-appointment-booking',
  templateUrl: 'schedule-appointment-booking.component.html',
})
export class ScheduleAppointmentBookingComponent extends CoreComponent {

  @Input() scheduleTypeId!: number;
  @Input() appointmentTypeId: number | undefined;

  @Output() onSelectPeriod: EventEmitter<BookingSlotDto | null> = new EventEmitter<BookingSlotDto | null>();

  constructor(protected router: Router, protected activatedRoute: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {
    this.refreshComponent()
  }

  refreshComponent() {
    this.initialized = true;
  }

  handleSelectPeriod(event: BookingSlotDto | null) {
    this.onSelectPeriod.emit(event);
  }


}
